import { render, staticRenderFns } from "./UsageHeatmapPanel.vue?vue&type=template&id=4b0ad4a6&scoped=true"
import script from "./UsageHeatmapPanel.vue?vue&type=script&lang=js"
export * from "./UsageHeatmapPanel.vue?vue&type=script&lang=js"
import style0 from "./UsageHeatmapPanel.vue?vue&type=style&index=0&id=4b0ad4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ad4a6",
  null
  
)

export default component.exports